import React from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { Badge, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import styles from './Changelog.module.scss'
import classNames from 'classnames'
import useChangelog from '../../../hooks/useChangelog'

const Changelog = () => {
  const { t } = useTranslation('homepage')
  const { data, error } = useChangelog(7)

  if (error) return <div className="text-center">{t('fetching.error' as any, { ns: 'layout' })}</div>
  if (!data) return <div className="text-center">{t('fetching.loading' as any, { ns: 'layout' })}</div>

  return (
    <div>
      {data.entries.map((entry, i) => (
        <div className={styles.changelogEntry} key={i}>
          <div className="d-flex flex-wrap align-content-center mb-2">
            <div className={classNames('me-3', styles.badgeContainer)}>
              <Badge bg={badgeColor(entry.category)}>{t(categoryTranslationKey(entry.category) as any)}</Badge>
            </div>
            <div className={classNames('me-3 position-relative', styles.titleContainer)}>
              <a href={entry.link} target="_blank" rel="noreferrer" className="stretched-link link-dark">
                {entry.title}
              </a>
            </div>
            <div className={classNames('text-muted', styles.titleContainer)}>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="2">{moment(entry.date).format('DD/MM/YYYY - HH:mm')}</Tooltip>}
              >
                <span className="pointer">{moment(entry.date).fromNow()}</span>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      ))}
      <div className="text-center mt-3">
        <Button
          variant="outline-primary"
          href="https://headwayapp.co/geartrack-updates"
          target="_blank"
          rel="noreferrer"
        >
          {t('changelog.see all')}
        </Button>
      </div>
    </div>
  )
}

function categoryTranslationKey(category) {
  category = category?.toLowerCase()
  return category ? `changelog.categories.${category}` : `changelog.categories.new`
}

function badgeColor(type: string) {
  type = type?.toLowerCase()

  switch (type) {
    case 'new':
      return 'success'
    case 'improvement':
      return 'info'
  }

  return 'secondary'
}

export default Changelog
